import * as React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Breadcrumbs from "../components/Breadcrumbs/breadcrumbs"
import { graphql } from "gatsby"
import { handleSearchWithMeiliSearch } from "../services/search"
import broad from "../images/placeholders/Full_width_banner.webp"
import QuicklinksCard from "../components/Quicklinks/quick-links"
import { CallBell, Headphones, TextIndent } from "@phosphor-icons/react"
import Banner from "../components/Banner"
import debounce from "lodash.debounce"
import { useState } from "react"
import { useEffect } from "react"

export const quicklinks = [
  {
    title: "Make a complaint",
    image: <Headphones size="" color="#ffffff" />,
    link: "https://play.telecel.com.gh/faults/reporting/",
  },
  {
    title: "Track Complaints",
    image: <TextIndent size="" color="#ffffff" />,
    link: "https://play.telecel.com.gh/faults/tracking/",
  },
  // {
  //   title: "Contact US",
  //   image: <CallBell size={200} color="#ffffff" />,
  //   link: "/personal/support/",
  // }
]

const HelpIndexPage = ({ data }) => {
  const categories = data.categoriesData.edges
  const [query, setQuery] = useState("")
  const [results, setResults] = useState(false)

  const handleAsYouType = event => {
    event.preventDefault()
    setQuery(event.target.value)
  }

  const handleAsYouTypeDebounced = debounce(
    event => handleAsYouType(event),
    500,
    {
      leading: false,
      trailing: true,
    }
  )

  const handleOutsideClick = event => {
    if (!event.relatedTarget.classList.contains("search-results")) {
      setResults(false)
    }
  }

  useEffect(() => {
    async function handleSearchWithMeiliSearchSync() {
      const response = await handleSearchWithMeiliSearch({ query })
      setResults(response.hits)
    }
    handleSearchWithMeiliSearchSync()
  }, [query])

  const handleSearchClick = event => {
    event.preventDefault()
    async function handleSearchWithMeiliSearchSync() {
      const response = await handleSearchWithMeiliSearch({ query })
      setResults(response.hits)
    }
    handleSearchWithMeiliSearchSync()
  }
  return (
    <Layout>
      <Seo
        title="Help - Home"
        keywords={[`telecel`, `ghana`, `support`, `help`]}
      />
      <div>
        {/* <Breadcrumbs Title={`Help`} TitleLink={`/help`} /> */}
        <div className="md:pt-50 pt-23 px-4">
          <Banner
            query={query}
            handleAsYouTypeDebounced={handleAsYouTypeDebounced}
            handleOutsideClick={handleOutsideClick}
            handleSearchClick={handleSearchClick}
            results={results}
            bannerContent={[
              {
                id: 1,
                title: "How can we help?",
                description: "",
                inputPlaceholder: "Type your query here",
                backgroundImage: broad,
              },
            ]}
          />
        </div>
      </div>

      <main className="px-4">
        <div className="container mx-auto my-15">
          <div className="pb-10">
            <h4 className="text-heading_sm pb-3 font-bold text-brand">
              Quick Links
            </h4>
            {/* <p className="text-body_base">
              Having Issues with any of our services?
            </p> */}
          </div>
          <div className="w-full">
            <div className="grid grid-cols-2 justify-items-center w-full gap-5">
              {quicklinks.map(quicklink => (
                <QuicklinksCard
                  title={quicklink.title}
                  svg={quicklink.image}
                  link={quicklink.link}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="container mx-auto my-15">
          <div className="pb-10">
            <h4 className="text-heading_sm pb-3 font-bold text-brand">
              Categories
            </h4>
            <p className="text-body_base">
              Find support for our products and services.
            </p>
          </div>
          <div className="w-full">
            <div className="grid grid-cols-2 md:grid-cols-4 justify-items-center w-full gap-5">
              {categories.map(({ node }) => (
                <QuicklinksCard
                  className="!bg-black border border-border_lighter hover:!bg-black"
                  title={node.name}
                  icon={node.icon}
                  key={node.name}
                  link={node.uri}
                />
              ))}
            </div>
          </div>
        </div>
      </main>
    </Layout>
  )
}

export const query = graphql`
  query HelpIndexPageQuery {
    categoriesData: allWpTopic(filter: { count: { gt: 0 } }) {
      edges {
        node {
          name
          uri
          count
          icon
        }
      }
    }
  }
`

export default HelpIndexPage
